const VERSION = "0.2.2-beta.0";
const PKGNAME = "@kspay/oversea-cashier-rn";
const RESULT_ENUMS = {
  // @kspay/oversea-cashier-jssdk中状态码也会从show/callack透出
  USER_CANCEL_HALFSCREEN_CASHIER: 1101 // 用户关闭半屏收银台
};

export { VERSION, PKGNAME, RESULT_ENUMS };